// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1cbI5","head":"Table_head__3IIHb","col":"Table_col__1tNZ3"};